<template>
  <Confirm ref="confirmRef" :max-width="maxWidth">
    <template v-slot:card-title="{ close }">
      <v-card-title class="alert-dialog__header">
        <div class="alert-dialog__header-inner">
          <span class="text-h6 alert-dialog__title">{{ displayTitle }}</span>
          <v-btn depressed icon class="alert-dialog__close" @click="close">
            <v-icon size="18">close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
    </template>

    <template v-slot:content>
      <div class="risk-dialog__message">
        {{ displayMessage }}
      </div>
    </template>
    <template v-slot:footer="{ close }">
      <v-spacer></v-spacer>
      <v-btn depressed text class="text-none" color="blue darken-1" @click="close">
        {{ $t('btn_close') }}
      </v-btn>
      <v-spacer></v-spacer>
    </template>
  </Confirm>
</template>

<script>
import Confirm from '@/components/Confirm.vue'

export default {
  name: 'RiskAlert',
  components: {
    Confirm
  },
  i18n: {
    sharedMessages: {
      en: {
        title: 'This action is currently unavailable for your account',
        message:
          'Some features are temporarily limited based on recent activity.\nAccess will be restored automatically once everything returns to normal.',
        btn_close: 'Close'
      },
      zh_CN: {
        title: '您的账户暂时无法执行此操作',
        message: '根据近期活动，部分功能暂时受限。\n一切恢复正常后，访问权限将自动恢复。',
        btn_close: '关闭'
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: String,
      default: '596px'
    }
  },
  computed: {
    displayTitle() {
      return this.title || this.$t('title')
    },
    displayMessage() {
      return this.message || this.$t('message')
    }
  },
  methods: {
    open(data) {
      if (this.$refs.confirmRef) {
        this.$refs.confirmRef.open(data)
      }
    },
    close() {
      if (this.$refs.confirmRef) {
        this.$refs.confirmRef.close()
      }
    }
  }
}
</script>

<style scoped>
.alert-dialog__header-inner {
  width: 100%;
  position: relative;
  text-align: center;
}

.alert-dialog__title {
  display: inline-block;
  padding: 0 28px;
}

.alert-dialog__close {
  position: absolute;
  top: -10px;
  right: -15px;
  margin: 0;
}

.risk-dialog__message {
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
  color: #000;
  white-space: pre-line;
}
</style>
